import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
// routes
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
// config
import { PATH_AFTER_LOGIN } from 'src/config-global';
import { useNavigate } from 'react-router';

// ----------------------------------------------------------------------

export default function LoginButton({ sx }) {
  const PATH_AFTER_LOGIN_2 = paths.auth.jwt.login;
  const navigate = useNavigate();

  const handleClick = () => {
    const token = localStorage.getItem('token');
    const rolesPresent = localStorage.getItem('rolesPresent');
    const selectedPreferences = localStorage.getItem('selectedPreferences');
    const selectedSubscrSite = localStorage.getItem('selectedSubscrSite');
    const user = localStorage.getItem('user');
    const userSession = localStorage.getItem('userSession');
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    const logoutEvent = localStorage.getItem('logoutEvent');

    sessionStorage.setItem('token', token);
    sessionStorage.setItem('rolesPresent', rolesPresent);
    sessionStorage.setItem('selectedPreferences', selectedPreferences);
    localStorage.setItem('selectedSubscrSite', selectedSubscrSite);
    localStorage.setItem('user', user);
    sessionStorage.setItem('userSession', userSession);
    sessionStorage.setItem('logoutEvent', logoutEvent);

    if (!token || !isAuthenticated) {
      console.log("🚨 Redirecting to Login Page...");
      // Clear session storage
      sessionStorage.clear();
      // Optionally, you can also clear local storage
      localStorage.clear();
      navigate(paths.auth.jwt.login);
    } else {
      console.log("Redirecting to dashboard...");
      navigate(paths.dashboard.root); // For v6
    }

  };

  return (
    <Button
      // component={RouterLink}
      href={PATH_AFTER_LOGIN_2}
      variant="outlined"
      sx={{ mr: 1, ...sx }}
      onClick={handleClick}
    >
      Login
    </Button>
  );
}

LoginButton.propTypes = {
  sx: PropTypes.object,
};


// import PropTypes from 'prop-types';
// // @mui
// import Button from '@mui/material/Button';
// // routes
// import { RouterLink } from 'src/routes/components';
// import { paths } from 'src/routes/paths';
// // config
// import { PATH_AFTER_LOGIN } from 'src/config-global';

// // ----------------------------------------------------------------------

// export default function LoginButton({ sx }) {
//   const PATH_AFTER_LOGIN_2 = paths.auth.jwt.login;
//   return (
//     <Button
//       // component={RouterLink}
//       href={PATH_AFTER_LOGIN_2}
//       variant="outlined"
//       sx={{ mr: 1, ...sx }}
//     >
//       Login
//     </Button>
//   );
// }

// LoginButton.propTypes = {
//   sx: PropTypes.object,
// };
